import { useEffect } from 'react'
import { useClearOnUnmount, useFieldHelpers } from '@/base'
import { Autocomplete, AutocompleteProps } from '../autocomplete'
import { FormField, FormFieldProps } from '.'

export const FormAutocomplete = (
  props: Omit<AutocompleteProps, 'value'> &
    Omit<FormFieldProps, 'children'> & {
      onChangeCallback?: (_?: string) => void
      shouldClearOnDismount?: boolean
    }
) => {
  const { onChangeCallback, name, label, schema, shouldClearOnDismount } = props
  const { field, helpers } = useFieldHelpers({ name, schema })
  useClearOnUnmount(shouldClearOnDismount, helpers.setValue)

  useEffect(() => {
    if (onChangeCallback) {
      onChangeCallback(field.value)
    }
  }, [field.value, onChangeCallback])

  return (
    <FormField
      name={name}
      label={label}
      schema={schema}
      message={props.message}
      description={props.description}
      optionalText={props.optionalText}
    >
      <Autocomplete
        placeholder={typeof label === 'string' ? label : undefined}
        {...props}
        {...field}
        value={field.value ?? ''}
        onSelect={(value) => {
          helpers.setValue(value)
        }}
      />
    </FormField>
  )
}
